/**
 * Shopify App Bridge CDN helpers.
 *
 * The CDN script (loaded in index.html) auto-initialises and exposes a
 * `shopify` global. These thin wrappers give us a single import site,
 * null-safety for the non-embedded case, and a clear migration seam.
 */

declare const shopify: any;

export function isEmbedded(): boolean {
  try {
    return shopify?.environment?.embedded ?? false;
  } catch {
    return false;
  }
}

/**
 * App Bridge's `host` (the admin's base64 host), or null outside the admin.
 * Read for the shell hop: boot scrubs `host` from the address bar, and a framed
 * hop target needs it to start App Bridge again (AS-11379 review).
 */
export function shopifyAdminHost(): string | null {
  try {
    const host = shopify?.config?.host;
    return typeof host === 'string' && host ? host : null;
  } catch {
    return null;
  }
}

export function redirectExternal(url: string): void {
  if (isEmbedded()) {
    open(url, '_top');
  } else {
    window.location.assign(url);
  }
}

export function redirectApp(path: string): void {
  if (isEmbedded()) {
    open(path, '_self');
  } else {
    window.location.assign(path);
  }
}

export async function getIdToken(): Promise<string | null> {
  try {
    return await shopify.idToken();
  } catch {
    return null;
  }
}
